import { useState, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnboarding } from '../OnboardingContext';
import { ResumeOnboardingModal } from '../ResumeOnboardingModal';
import paynovusLogo from '@/assets/paynovus-logo-horizontal-tagline-white.svg';

export const WelcomeStep = forwardRef<HTMLDivElement>(function WelcomeStep(_props, ref) {
  const { t } = useTranslation();
  const { setCurrentStep, restoreSession, resetOnboarding, data } = useOnboarding();
  const [showResumeModal, setShowResumeModal] = useState(false);

  const handleGetStarted = () => {
    // Always start fresh — data can only be restored via "Resume Existing Application"
    resetOnboarding();
    setCurrentStep('account-type');
  };

  const handleResume = (data: {
    currentStep: string;
    accountType: string;
    onboardingData: Record<string, unknown>;
    sessionToken: string;
    email: string;
  }) => {
    restoreSession(data);
  };

  return (
    <>
      <div ref={ref} className="hero-dark flex flex-col items-center justify-between p-4 sm:p-6 text-white safe-area-inset-top safe-area-inset-bottom">
        <div className="flex-1 flex flex-col items-center justify-center text-center max-w-md px-2 animate-fade-in-up">
          <img src={paynovusLogo} alt="PayNovus – Beyond Payments" className="h-14 sm:h-20 w-auto mb-6 sm:mb-8" />
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4 leading-tight">
            {t('welcome.title')}
          </h1>
          
          <p className="text-white/70 text-base sm:text-lg mb-6 sm:mb-8">
            {t('welcome.subtitle')}<br />
            {t('welcome.description')}
          </p>
        </div>

        <div className="w-full max-w-md space-y-3 sm:space-y-4 pb-4 sm:pb-8 px-2">
          <button
            onClick={handleGetStarted}
            className="w-full py-4 px-6 bg-accent text-accent-foreground font-semibold rounded-full hover:bg-accent/90 active:scale-[0.98] transition-all duration-300 shadow-lg text-base sm:text-lg"
            style={{ minHeight: '56px' }}
          >
            {t('welcome.getStarted')}
          </button>
          
          <button 
            onClick={() => setShowResumeModal(true)}
            className="w-full py-3 sm:py-4 px-6 text-white/80 font-medium hover:text-white active:text-white/60 transition-colors text-sm sm:text-base"
            style={{ minHeight: '48px' }}
          >
            {t('welcome.resumeApplication')}
          </button>
          
        </div>
      </div>

      <ResumeOnboardingModal
        isOpen={showResumeModal}
        onClose={() => setShowResumeModal(false)}
        onResume={handleResume}
      />
    </>
  );
});
